<template>
  <hilo-modal
    :isVisible="true"
    :unCloseable="true"
    title="Coming soon!"
    :footerButtons="modalButtons"
  >
    <div style="display: flex; flex-direction: column; align-items: center">
      <div>This page is currently under construction!</div>
      <img
        src="./../../../public/static/img/Building the plane while flying it.png"
        width="340px"
        height="340px"
        alt="Building the plane while flying it"
      />
    </div>
  </hilo-modal>
</template>

<script>
import HiloModal from "@/components/HiloComponents/HiloModal.vue";

export default {
  components: { HiloModal },
  data() {
    return {
      modalButtons: [
        {
          label: "Go to Homepage",
          onClick: this.navigateToHomepage,
        },
      ],
    };
  },
  methods: {
    navigateToHomepage() {
      this.$router.push(`/hilo/homeScreen`);
    },
  },
};
</script>

<style scoped></style>
